export enum MissionWarningType {
  GIS_UNAVAILABLE = 'GIS_UNAVAILABLE',
}
